import React from "react";

/**
 * Infinite horizontal ticker. items: array of strings.
 */
export const Marquee = ({ items, slow = false, className = "", testid }) => {
  const list = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} data-testid={testid}>
      <div className={`marquee-track ${slow ? "slow" : ""}`}>
        {list.map((it, i) => (
          <span
            key={i}
            className="mono text-[11px] sm:text-[12px] tracking-[0.18em] uppercase text-[#F5F1E8]/55 px-6 sm:px-8 flex items-center gap-6 whitespace-nowrap"
          >
            {it}
            <span className="text-[#C5D4B5]/40">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
